import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { max: { type: Number, default: 4 } }

  connect() {
    this.onChange = this.onChange.bind(this)
    this.onClick = this.onClick.bind(this)
    this.element.addEventListener("change", this.onChange)
    this.element.addEventListener("click", this.onClick)
    this.updateBar()
  }

  disconnect() {
    this.element.removeEventListener("change", this.onChange)
    this.element.removeEventListener("click", this.onClick)
  }

  onChange(event) {
    const checkbox = event.target.closest(".compare-checkbox")
    if (!checkbox) return

    if (checkbox.checked && this.checkedBoxes().length > this.maxValue) {
      checkbox.checked = false
      this.showToast(`You can compare up to ${this.maxValue} cards at a time`)
    }
    this.updateBar()
  }

  onClick(event) {
    const clearButton = event.target.closest("#compare-clear")
    if (clearButton) {
      this.checkedBoxes().forEach((box) => {
        box.checked = false
      })
      this.updateBar()
      return
    }

    const compareButton = event.target.closest("#compare-btn")
    if (!compareButton || compareButton.disabled) return

    const ids = this.selectedItems().map((item) => item.id)
    window.location.href = `/compare?${ids.map((id) => `ids[]=${id}`).join("&")}`
  }

  checkedBoxes() {
    return Array.from(this.element.querySelectorAll(".compare-checkbox:checked"))
  }

  selectedItems() {
    return this.checkedBoxes()
      .slice(0, this.maxValue)
      .map((box) => ({ id: box.dataset.id, name: box.dataset.name }))
  }

  updateBar() {
    const selected = this.selectedItems()
    const count = selected.length
    const names = selected.map((item) => item.name)

    const compareBar = this.element.querySelector("#compare-bar")
    if (compareBar) compareBar.classList.toggle("hidden", count === 0)

    for (let i = 0; i < this.maxValue; i += 1) {
      const slot = this.element.querySelector(`#compare-slot-${i}`)
      if (!slot) continue
      if (names[i]) {
        slot.textContent = names[i]
        slot.className = "text-sm font-medium text-gray-800 truncate max-w-[140px]"
      } else {
        slot.textContent = "—"
        slot.className = "text-sm text-gray-300"
      }
    }

    const compareButton = this.element.querySelector("#compare-btn")
    if (compareButton) compareButton.disabled = count < 2

    const hint = this.element.querySelector("#compare-hint")
    if (hint) hint.textContent = count === 1 ? "Select 1 more card to compare" : ""

    const navButton = document.getElementById("nav-compare-btn")
    if (navButton && window.matchMedia("(min-width: 768px)").matches) {
      if (count >= 2) {
        const ids = selected.map((item) => item.id)
        navButton.href = `/compare?${ids.map((id) => `ids[]=${id}`).join("&")}`
        navButton.classList.replace("hidden", "inline-flex")
      } else {
        navButton.classList.replace("inline-flex", "hidden")
      }
    }
  }

  showToast(message) {
    const toast = this.element.querySelector("#compare-toast")
    if (!toast) return
    toast.textContent = message
    toast.classList.remove("hidden")
    clearTimeout(this.toastTimer)
    this.toastTimer = setTimeout(() => toast.classList.add("hidden"), 2500)
  }
}
